/* Manifold reviews marquee — builds cards from window.ML_REVIEWS (assets/ml-reviews-data.js).
   Works on any .ml-reviews__track:
     - no data-handle           -> all reviews (home "What people are saying"), with product links
     - data-handle="<handle>"   -> only reviews for that product (PDP), product link hidden
   Scrolls slowly and continuously when the set is wider than the viewport (duplicates for a seamless
   loop); otherwise lays the few cards out statically. Pauses on hover/focus; respects reduced motion.
   A filtered track with no reviews shows a "No reviews yet." message (.ml-reviews__empty). */
(function () {
  if (!window.ML_REVIEWS || !window.ML_REVIEWS.length) return;

  var SPEED = 45; // px per second — gentle drift

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function stars(r) {
    var s = '';
    for (var i = 1; i <= 5; i++) s += '<span class="ml-review__star' + (i <= r ? '' : ' is-off') + '">★</span>';
    return s;
  }
  // "Justin Jackerson" -> "Justin J." ; single names stay whole
  function shortName(n) {
    n = (n || '').trim();
    if (!n) return 'Anonymous';
    var parts = n.split(/\s+/);
    if (parts.length === 1) return parts[0];
    var last = parts[parts.length - 1].replace(/[^A-Za-z].*$/, '');
    return parts.slice(0, -1).join(' ') + ' ' + (last ? last.charAt(0).toUpperCase() + '.' : '');
  }
  var VERIFIED =
    '<span class="ml-review__verified" title="Verified buyer" aria-label="Verified buyer">' +
    '<svg class="ml-review__check" viewBox="0 0 16 16" width="14" height="14" aria-hidden="true">' +
    '<circle cx="8" cy="8" r="8" fill="currentColor"></circle>' +
    '<path d="M4.4 8.3l2.2 2.2 4.9-4.9" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path>' +
    '</svg></span>';

  var ARROW =
    '<svg class="ml-review__arrow" viewBox="0 0 16 16" width="11" height="11" fill="none" ' +
    'stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M4.5 11.5l7-7M6 4.5h5.5V10"/></svg>';
  // The product a review is about: a link to its page when it's still on the menu, otherwise just the
  // name. Hidden entirely on a product page (you're already there).
  function productHTML(rev, hideProduct) {
    if (hideProduct || !rev.p) return '';
    if (rev.h) {
      return '<a class="ml-review__product" href="/products/' + encodeURIComponent(rev.h) + '">' +
        esc(rev.p) + ARROW + '</a>';
    }
    return '<span class="ml-review__product ml-review__product--past">' + esc(rev.p) + '</span>';
  }

  function cardHTML(rev, hideProduct) {
    return '<div class="ml-review__stars" role="img" aria-label="' + rev.r + ' out of 5 stars">' + stars(rev.r) + '</div>' +
      '<p class="ml-review__body">' + esc(rev.b) + '</p>' +
      productHTML(rev, hideProduct) +
      '<p class="ml-review__by"><span class="ml-review__name">' + esc(shortName(rev.n)) + '</span>' + VERIFIED +
      (rev.d ? '<span class="ml-review__date">' + esc(rev.d) + '</span>' : '') + '</p>';
  }

  function makeCard(rev, hideProduct, clone) {
    var li = document.createElement('li');
    li.className = 'ml-review';
    li.innerHTML = cardHTML(rev, hideProduct);
    if (clone) {
      li.setAttribute('aria-hidden', 'true');
      var a = li.querySelector('a');
      if (a) a.setAttribute('tabindex', '-1'); // clone links stay out of the tab order
    }
    return li;
  }

  function build(track) {
    var handle = track.getAttribute('data-handle');
    var hideProduct = track.hasAttribute('data-hide-product') || !!handle;
    var data = window.ML_REVIEWS;
    if (handle) data = data.filter(function (r) { return r.h === handle; });

    var viewport = track.closest('.ml-reviews__viewport');
    var container = track.closest('.ml-reviews');

    if (!data.length) {
      if (viewport) viewport.hidden = true;
      var empty = container && container.querySelector('.ml-reviews__empty');
      if (empty) empty.hidden = false;
      return null;
    }

    var n = data.length;
    // Real set first.
    var frag = document.createDocumentFragment();
    data.forEach(function (rev) { frag.appendChild(makeCard(rev, hideProduct, false)); });
    track.appendChild(frag);

    function setup() {
      track.classList.remove('is-rolling', 'is-static');
      track.style.animationDuration = '';
      track.style.removeProperty('--ml-shift');
      if (viewport) viewport.classList.remove('is-static');
      // Drop any clone cards from a previous pass.
      while (track.children.length > n) track.removeChild(track.lastChild);

      var setWidth = track.scrollWidth;
      var vpWidth = (viewport || track.parentElement).clientWidth;
      if (setWidth <= vpWidth + 4) {
        // Few reviews — lay them out statically, no scroll, no edge fade.
        track.classList.add('is-static');
        if (viewport) viewport.classList.add('is-static');
        return;
      }
      // Enough to scroll — append a clone set and run the marquee.
      var clones = document.createDocumentFragment();
      data.forEach(function (rev) { clones.appendChild(makeCard(rev, hideProduct, true)); });
      track.appendChild(clones);
      var shift = track.children[n].offsetLeft - track.children[0].offsetLeft;
      if (!shift) return;
      track.style.setProperty('--ml-shift', shift + 'px');
      track.style.animationDuration = (shift / SPEED).toFixed(1) + 's';
      track.classList.add('is-rolling');
    }

    return setup;
  }

  var setups = [];
  document.querySelectorAll('.ml-reviews__track').forEach(function (track) {
    var fn = build(track);
    if (fn) setups.push(fn);
  });
  if (!setups.length) return;

  function runAll() { setups.forEach(function (fn) { fn(); }); }
  if (document.readyState === 'complete') runAll();
  else window.addEventListener('load', runAll);
  // Recompute on resize (card widths are responsive).
  var rt;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(runAll, 200); });
})();
